export const SEARCH_TEXT_PACKAGE_TAB = `
Browse sailings with bonus savings and special extras, or choose from our exclusive vacation packages with air,
hotel, tours and more - only available at Online Vacation Center!
`;
